import PropTypes from 'prop-types';
import React from "react";
import { Link } from 'react-router-dom';
import { Tooltip } from '../Tooltip/Tooltip';

export const Button = ({
    type = "primary",
    iconOnly,
    target,
    tag,
    href,
    id,
    size = "small",
    state,
    label,
    iconLeft,
    iconRight,
    microLoading,
    tooltip,
    cssclass,
    ...props
}) => {
    const isDisabled = state === "disabled";
    const handleClick = isDisabled ? undefined : props.onClick;

    const baseClass = type === "ghost" || type === "secondary" ? `${type}-btn` : "btn";
    const sizeClass = size ? `${type}-${size}` : type;
    const stateClass = state ? `btn-${state}` : "";
    const iconClass = iconLeft || iconRight ? "btn-with-icon" : "";
    const iconLeftClass = iconLeft ? "btn-with-icon-left" : "";
    const iconRightClass = iconRight ? "btn-with-icon-right" : "";

    const content = microLoading ? (
        <div className="micro-loading">
            <div className="three-balls">
                <div className="ball ball1" />
                <div className="ball ball2" />
                <div className="ball ball3" />
            </div>
        </div>
    ) : (
        <>
            {iconLeft || null}
            {!iconOnly ? label : null}
            {iconRight || null}
        </>
    );

    if (!tag) {
        return (
            <button
                id={id}
                onClick={handleClick}
                disabled={isDisabled}
                className={`${baseClass} ${sizeClass} ${stateClass} ${iconClass} ${iconLeftClass} ${iconRightClass} ${cssclass || ""} ${microLoading ? "no-hover-state" : ""}`.trim()}
            >
                {content}
                {iconOnly && <Tooltip data={label} type="top" />}
                {tooltip && <Tooltip data={tooltip} type="bottom" style={{ display: "block" }} />}
            </button>
        );
    }

    if (tag === "link") {
        return (
            <Link
                to={href}
                className={`${baseClass} ${sizeClass} ${stateClass} ${iconClass} ${iconLeftClass} ${iconRightClass}`.trim()}
            >
                {content}
            </Link>
        );
    }

    return (
        <a
            id={id}
            href={href}
            target={target}
            onClick={handleClick}
            className={`${baseClass} ${sizeClass} ${stateClass} ${iconClass} ${iconLeftClass} ${iconRightClass}`.trim()}
        >
            {content}
        </a>
    );
};

Button.propTypes = {
    type: PropTypes.oneOf(["primary", "secondary", "ghost"]),
    size: PropTypes.oneOf(["small", "medium", "large"]),
    state: PropTypes.oneOf(["", "active", "disabled"]),
    microLoading: PropTypes.bool,
    label: PropTypes.any,
};
